import {Future, asFuture} from 'external/dev_april_corgi+/js/common/futures';
import {waitMs} from 'external/dev_april_corgi+/js/common/promises';

const outstanding: Array<Future<unknown>> = [];

export function fireAndForget(p: Promise<unknown> | Future<unknown>): void {
  let finished = false;
  const racing = Promise.race([
    p
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        finished = true;
      }),
    waitMs(5000).finally(() => {
      if (!finished) {
        console.error("Forgotten promise didn't resolve within 5 seconds");
      }
    }),
  ]);

  outstanding.push(asFuture(racing));

  const copy = outstanding.filter(f => !f.finished);
  outstanding.length = 0;
  outstanding.push(...copy);
}
